export const INITIAL_ENTRY_SESSION_KEY = 'initialEntry';

export const MOST_RECENT_SEARCH_KEYWORDS = 8;

export const MOST_RECENT_BROWSE_PRODUCTS = 20;

export const CUSTOM_TAILWIND_CSS_DEVELOPMENT_PATH = '/custom-tailwind.css';

export const CUSTOM_TAILWIND_CSS_PRODUCTION_PATH =
  '/_ui/responsive/theme-trplus/app/src/dist/old_dist/custom-tailwind.css';
